const { LocalStorageKey } = require("../common/constant");

/**
 * Save data in Session Storage
 * @param {string} name - key for data
 * @param {string} data - data to store
 */
function saveSession(name, data) {
  localStorage.setItem(name, data);
}

/**
 * Recover data from Session Storage
 * @param {string} name - key for data to recover
 */
function recoverSession(name) {
  return localStorage.getItem(name) || sessionStorage.getItem(name);
}

function removeToken() {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("accessToken");

  sessionStorage.removeItem("token");
  sessionStorage.removeItem("refreshToken");
  sessionStorage.removeItem("accessToken");
}

/**
 * Delete all data in Session Storage
 */
function deleteSession() {
  localStorage.clear();
  sessionStorage.clear();
}

/**
 * Serialize and save user data in Session Storage
 * @param {string|number|Array|Object} data - data to store
 */
function storeUserDataOnlocalStorage(data) {
  const replacer = (key, value) => {
    if (typeof value === "boolean" || typeof value === "number") {
      return String(value);
    }
    return value;
  };
  sessionStorage.setItem("userData", JSON.stringify(data, replacer));
  localStorage.setItem("userData", JSON.stringify(data, replacer));
}

/**
 * Recover and unserialize user data from Session Storage
 * @return {Object}
 */
function recoverUserDataFromlocalStorage() {
  const reviver = (key, value) => {
    if (value === "true") {
      return true;
    }
    if (value === "false") {
      return false;
    }
    return value;
  };
  if (sessionStorage.getItem("userData")) {
    return JSON.parse(sessionStorage.getItem("userData"), reviver) || {};
  }
  return JSON.parse(localStorage.getItem("userData"), reviver) || {};
}

/**
 * Delete user data in Session Storage
 */
function deleteUserDataFromlocalStorage() {
  localStorage.removeItem("userData");
  sessionStorage.removeItem("userData");
}

function getLocalTokens() {
  if (typeof window === "undefined") {
    return { accessToken: null, refreshToken: null };
  }
  if (sessionStorage?.getItem(LocalStorageKey.ACCESS_TOKEN)) {
    return {
      accessToken: sessionStorage?.getItem(LocalStorageKey.ACCESS_TOKEN),
      refreshToken: sessionStorage?.getItem(LocalStorageKey.REFRESH_TOKEN),
    };
  }

  return {
    accessToken: localStorage?.getItem(LocalStorageKey.ACCESS_TOKEN),
    refreshToken: localStorage?.getItem(LocalStorageKey.REFRESH_TOKEN),
  };
}

function deleteLocalTokens() {
  localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
  localStorage.removeItem(LocalStorageKey.REFRESH_TOKEN);

  sessionStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
  sessionStorage.removeItem(LocalStorageKey.REFRESH_TOKEN);
}

function saveLocalTokens({ accessToken, refreshToken }) {
  localStorage.setItem(LocalStorageKey.ACCESS_TOKEN, accessToken);
  localStorage.setItem(LocalStorageKey.REFRESH_TOKEN, refreshToken);
}

function saveSessionTokens({ accessToken, refreshToken }) {
  sessionStorage.setItem(LocalStorageKey.ACCESS_TOKEN, accessToken);
  sessionStorage.setItem(LocalStorageKey.REFRESH_TOKEN, refreshToken);
}

module.exports = {
  saveSession,
  recoverSession,
  deleteSession,
  storeUserDataOnlocalStorage,
  recoverUserDataFromlocalStorage,
  deleteUserDataFromlocalStorage,
  getLocalTokens,
  deleteLocalTokens,
  saveLocalTokens,
  removeToken,
  saveSessionTokens,
  // refreshAccessToken,
};
